import _ from "lodash";
import {IVirtualizedTableColumn} from "../components/Table/VirtualizedTableInterfaces";

export interface ILocalStorageUserProperties {
    columnSizeSetting: any;
    rowSort: string[];
    rowVisibleList: any;
}

export class UserDynTableProperty {

    private localStorageKey: string;
    private rows: IVirtualizedTableColumn[];

    public constructor (localStorageKey: string, rows: IVirtualizedTableColumn[]) {
        this.localStorageKey = localStorageKey;
        this.rows = rows;
    }

    /**
     * Creates a @ILocalStorageUserProperties item in browser's local storage,
     * with a given key and default values for every entry.
     */
    public create = (): ILocalStorageUserProperties | null => {

        let _columnSizeSetting = {};
        let _rowSort = this.rows.map((row: IVirtualizedTableColumn) => row.key);
        let _rowVisibleList = {};

        this.rows.forEach((row: IVirtualizedTableColumn) => {
            _columnSizeSetting[row.key] = {
                width: row.options ? (row.options.cellWidth ? row.options.cellWidth : 100) : 100
            };
            _rowVisibleList[row.key] = {
                visible: row.options ? (row.options.showOnStart !== undefined && row.options.showOnStart !== null ? row.options.showOnStart : true) : true
            };
        });
        
        let localStorageObject: ILocalStorageUserProperties = {
            columnSizeSetting: _columnSizeSetting,
            rowSort: _rowSort,
            rowVisibleList: _rowVisibleList
        };

        return localStorageObject;
    }

    /**
     * Updates the local storage item from the browser from the dyn table context.
     * Adds new columns if they dont exists, removes the columns that are not used in
     * the application anymore and updates the values of existing columns.
     */
    public update = (rows: IVirtualizedTableColumn[], columnSizeSetting: any, rowVisibleList: any, rowSort: string[]): ILocalStorageUserProperties | null => {
        let localStorageItem: any | null = this.get();

        if (localStorageItem !== null) {
            
            let newLocalStorageItem: ILocalStorageUserProperties = _.clone(localStorageItem);

            // Add the new keys
            rows.forEach((row: IVirtualizedTableColumn) => {
                if (columnSizeSetting[row.key] !== undefined) {
                    newLocalStorageItem.columnSizeSetting[row.key] = columnSizeSetting[row.key];
                } else { 
                    newLocalStorageItem.columnSizeSetting[row.key] = {width: row.options ? row.options.cellWidth : 100};
                }

                if (rowVisibleList[row.key] !== undefined) {
                    newLocalStorageItem.rowVisibleList[row.key] = rowVisibleList[row.key];
                } else {
                    let visible: boolean = row.options ? (row.options.showOnStart !== undefined && row.options.showOnStart !== null ? row.options.showOnStart : true) : true;
                    newLocalStorageItem.rowVisibleList[row.key] = {visible: visible};
                }

                newLocalStorageItem.rowSort = rowSort;

            });

            // Remove unused keys
            let rowKeys: string[] = rows.map((row: IVirtualizedTableColumn) => row.key);
            newLocalStorageItem.rowSort.forEach((key: string, index: number) => {
                if (rowKeys.indexOf(key) === -1) {
                    newLocalStorageItem.rowSort.splice(index);
                }
            });

            Object.keys(newLocalStorageItem.columnSizeSetting).forEach((key: string) => {
                if (rowKeys.indexOf(key) === -1) {
                    delete newLocalStorageItem.columnSizeSetting[key];
                }
            });

            Object.keys(newLocalStorageItem.rowVisibleList).forEach((key: string) => {
                if (rowKeys.indexOf(key) === -1) {
                    delete newLocalStorageItem.rowVisibleList[key];
                }
            });

            return newLocalStorageItem;

        } else {
            console.error ("Local storage item does not exists");
        }

        return null;
    }

    /**
     * Saves in browsers local storage a given @ILocalStorageUserProerties as string.
     * @localStorageItem the item that will be saved
     */
    public save = (localStorageItem: ILocalStorageUserProperties | null) => {
        if (localStorageItem) {
            localStorage.setItem(this.localStorageKey, JSON.stringify(localStorageItem));
        }
    }

    /**
     * Retreives from browsers local storage, if exists, the current ILocalStorageUserProperteis
     * 
     * @return - @ILocalStorageUserProperties if exists, null otherwise
     */
    public get = (): ILocalStorageUserProperties | null => {
        let localStorageItem: string | null = localStorage.getItem(this.localStorageKey);

        if (localStorageItem) {
            return JSON.parse(localStorageItem);
        } 

        return null;
    }

}


// WEBPACK FOOTER //
// ./src/services/UserDynTableProperties.ts